import styles from './AcceptCookie.module.css'
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setAcceptCookie} from "../../Reducer/GlobalReducer";
import {Link} from "react-router-dom";
import React from "react";
import {useIsMobile} from "../../Util/CheckMobile";
export default function AcceptCookie(){
    const acceptCookie = useSelector((state:ReduxStateInt)  => {return state.acceptCookie});
    const dispatch = useDispatch();
    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })


    if(acceptCookie) return null
    return(
        <div className={[styles.mainCont].join(' ')}>
            <div className={styles.cont}>Этот сайт использует файлы cookies и сервисы сбора технических данных посетителей  для обеспечения работоспособности и улучшения качества обслуживания. Продолжая использовать наш сайт, Вы автоматически соглашаетесь с использованием данных технологий.</div>

            <Link to={baseUrl + "/static/ppd-politic.docx"} >
                Политика обработки персональных данных
            </Link>

            <div className={styles.btn}
                onClick={()=>dispatch(setAcceptCookie(true))}
            >Принять</div>
        </div>
    )
}